import React from 'react'
import { getApiFieldValue } from '../../services/commonService';
import { updateData } from '../../services/accIqService';

export default function SubmitActionButton({
    page = '', checkedItems = [],
    setCheckedItems = () => {},
    action = '',
    currentPage = '',
    setSelectAll = () => {},
    setupdateDataStatus = () => {},
    setSuccessMessage = () => {},
    setCurrentPage = () => {},
    setLoader = () => {},
    setAction = () => {}
}) {

    const handleActionSubmit = async () => {
        if(action !== undefined || action !== null || action !== ""){
          setLoader(true);
          const param = getApiFieldValue(action);
          let api_param = (page === 'companies') ? 'company_ids' : ((page === 'users') ? 'user_ids' : ((page === 'accounts') ? 'account_ids' : ''))

          if(api_param !== ''){
            const formattedData = {
                [api_param]: checkedItems,
                field: param.field,
                value: param.value
            };
            try {
                let update_data = await updateData(page, formattedData);
                // console.log("UPDATE DATA: "+JSON.stringify(update_data));
                setCurrentPage(currentPage);
                if(update_data.status == 200){
                setCheckedItems([]);
                setSelectAll(false);
                setupdateDataStatus(true);
                setSuccessMessage(page.charAt(0).toUpperCase()+page.slice(1)+" data updated successfully");
                setAction({action:''});
                setTimeout(() => {
                    setSuccessMessage("");
                    setupdateDataStatus(false);
                }, 5000);
                }else{
                setupdateDataStatus(false);
                }
            } catch (error) {
                console.error("Error updating data:", error);
            } finally {
                // setLoading(false); // Set loading to false after data is fetched
            }
          setLoader(false);
         }
        }
    }

    return (
        <div className="col col-md-3 submit_action">
        <button className={`btn btn-primary ${(checkedItems.length > 0 && action !== '') ? '' : 'disabled'}`} onClick={handleActionSubmit}>
            Submit
        </button>
        </div>
    );
}
